import { useState } from "react";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import IconButton from "@mui/material/IconButton";
import { ChevronLeft, ChevronRight, Close } from "@mui/icons-material";
import { Container, Grid, Typography } from "@mui/material";

const Gallery1 = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = Array.from({ length: 10 }, (_, i) => ({
    img: `/Gallery${i +1}.jpeg`, 
  }));
  

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <Container
    sx={{
      marginTop:'25vh',
      alignItems:'center',
      justifyContent:'center',
      display:'flex',
      flexDirection:'column'
    }}
    >
      <Typography
      
  variant="h5"
  textAlign="center"
  sx={{
    fontWeight: "bold",
    color: "#333",
    textTransform: "uppercase",
    marginBottom: 2,
    fontFamily: "Roboto Slab, serif",
    borderBottom: "2px solid red", 
    paddingBottom: "8px", 
    display: "inline-block", 
  }}
>
  Unsere Arbeiten
</Typography>
       <Grid container
    sx={{
      justifyContent:'center',
      alignItems:'center',
    }}
    >
      <Grid item xs={12} md={12}>
      <Box sx={{ width: '100%', margin: "auto", padding: 1 }}>
      <ImageList variant="masonry" cols={4} gap={5}>
  {images.map((item, index) => (
    <ImageListItem key={item.img} onClick={() => openModal(index)} sx={{ cursor: "pointer" }}>
      <div
        style={{
          width: "100%", 
          height: "auto", 
          overflow: "hidden", 
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <img
          src={`${item.img}?w=248&fit=crop&auto=format`}
          srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
          alt="EMN"
          loading="lazy"
          style={{
            width: "100%", 
            height: "auto", 
            transition: "transform 0.3s ease-in-out", 
            borderRadius: "8px",

          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.2)"; 
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)"; 
          }}
        />
      </div>
      <ImageListItemBar position="below" />
    </ImageListItem>
  ))}
</ImageList>


      {/* Modal for full image view */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={closeModal}
        >
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              closeModal();
            }}
            sx={{
              position: "absolute",
              top: "20px",
              right: "20px",
              color: "white",
              zIndex: 1001,
            }}
          >
            <Close />
          </IconButton>
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: "20px",
              color: "white",
              zIndex: 1001,
            }}
          >
            <ChevronLeft fontSize="large" />
          </IconButton>
          <img
            src={images[currentIndex].img}
            alt={images[currentIndex].title}
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
            }}
          />
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: "20px",
              color: "white",
              zIndex: 1001,
            }}
          >
            <ChevronRight fontSize="large" />
          </IconButton>
        </div>
      )}
    </Box>

      </Grid>
    </Grid>

    </Container>
   
   
  );
};

export default Gallery1;
